import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineTrash } from "react-icons/hi";
import { Button } from "@mui/material";

import { TiTick } from "react-icons/ti";
import {
  useAddTreatmentsMutation,
  useDeleteTreatmentMutation,
  useGetTreatmentsMasterQuery,
  useGetTreatmentsQuery,
  useUpdateTreatmentMutation,
} from "../../../Service/treatments";
import { validate } from "../../../utils";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import PermissionCheck from "../../../Component/PermissionCheck";
import AntSwitch from "../../../Component/DigitalMarketing/AntSwitch";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
function Treatments() {
  const data = [
    { name: "Treatments 1" },
    { name: "Treatments 2" },
    { name: "Treatments 3" },
    { name: "Treatments 4" },
  ];
  const [show, setshow] = useState<any>(false);
  const [list, setlist] = useState<any>(data);
  const [submit, setSubmit] = useState(false);
  const [val, setval] = useState<any>("");
  const dispatch = useDispatch<any>();
  const [pagination, setpagination] = useState(1);

  const pagi = {
    pageNo: pagination,
   
  };
  const { open, message, openSnackBar, type } = useSnackbar();
  const permission = useSelector((state: any) => state.auth.permission);
  const { data: TreatmentResponse,isLoading, refetch } =  useGetTreatmentsMasterQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  // console.log(TreatmentResponse);

  
  const [addTreatments] = useAddTreatmentsMutation();
  const [deleteTreatment] = useDeleteTreatmentMutation();
  const [updateTreatment] = useUpdateTreatmentMutation();
  const {
    open: open1,
    message: message1,
    openDelete,
    deleteId,
  } = useDeleteBox();
  useEffect(() => {
    const data: any = {
      first: "Treatments",
    };
    dispatch(Change(data));
  }, [dispatch]);
  useEffect(() => {
    
  }, [pagination])

  const Add = async () => {
    setSubmit(true);
    if (val.trim().length !== 0) {
      try {
        const payload = await addTreatments({
          treatment_type_name: val,
          active_status: 1,
        }).unwrap();
        // console.log("fulfilled", payload);
        openSnackBar("Added successfully");
        refetch();
      } catch (error: any) {
        openSnackBar(error.data.error, "error");
        console.error("rejected", error);
      }
      setval("");
      setshow(false);
      setSubmit(false);
    }
  };

  // const Delete = async (id) => {
  //   await deleteTreatment(id);
  //   openSnackBar("Deleted successfully");
  // };

  const onChange = async (id, event, check = false) => {
    setSubmit(false);
    if (check) {
      try {
        const payload = await updateTreatment({
          id,
          [event.target.name]: check
            ? event.target.checked
              ? 1
              : 0
            : event.target.value,
        }).unwrap();
        // console.log("fulfilled", payload);
        openSnackBar("Updated successfully");
        refetch();
      } catch (error: any) {
        openSnackBar(error.data.error, "error");
        console.error("rejected", error);
      }
    } else {
      if (validate(event.target.value)) {
        try {
          const payload = await updateTreatment({
            id,
            [event.target.name]: check
              ? event.target.checked
                ? 1
                : 0
              : event.target.value,
          }).unwrap();
          // console.log("fulfilled", payload);
          openSnackBar("Updated successfully");
        } catch (error: any) {
          openSnackBar(error.data.error, "error");
          console.error("rejected", error);
        }
      } else {
        setSubmit(true);
      }
    }
  };
  const Delete = async (bool) => {
    if (bool) {
      await deleteTreatment(deleteId);
      refetch();
      openSnackBar("Deleted successfully");
    }
    openDelete("Are you sure you want to delete this treatment?", false, null);
  };
  useEffect(() => {
    if(TreatmentResponse===undefined){
      refetch();
    }
    // console.log("TreatmentResponse", TreatmentResponse);
  }, [TreatmentResponse,refetch]);
  return (
    <div className="mt-5">
      <Toast open={open} type={type} message={message} />
      <>
        <AlertDialog open={open1} message={message1} deleteBranches={Delete} />
      </>
      {PermissionCheck("user_management", "view") &&
        TreatmentResponse?.data &&
        TreatmentResponse?.data.map((a, i) => {
          return (
            <RenderData
              a={a}
              key={a.id}
              onChange={onChange}
              openDelete={openDelete}
              submit={submit}
            />
          );
        })}

      {show ? (
        <div
          className="list-type-input"
          style={{ border: submit && !validate(val) ? "1px solid red" : "" }}
        >
          <input
            type="text"
            placeholder="Type your treatment and click “Enter” "
            className="text-custom-contain add-new"
            value={val}
            onChange={(e) => {
              setval(e.target.value);
              setSubmit(false);
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                Add();
              }
            }}
          />
             {/* <TiTick className={val===""?"tick-inactive cursur":"tick cursur"} onClick={Add} /> */}
        </div>
      ) : (
        ""
      )}
      {PermissionCheck("treatment_types", "add") && (
        <div className="button-contain mt-3 mb-5">
          <Button
            variant="contained"
            id="btn-grey"
            onClick={() => setshow(!show)}
          >
            {show ? "Back" : "+ Add Treatments"}
          </Button>
          {!isLoading &&<Pagination setpagination={setpagination} pagination={pagination} data={TreatmentResponse}/> }
        </div>
      )}
    </div>
  );
}

const RenderData = (props) => {
  const { onChange, a, openDelete, submit } = props;
  // console.log(a);
  
  const [val, setVal] = useState(a.treatmentTypeName);
  const [checked, setChecked] = useState(a.active_status == 1);
  useEffect(() => {
    setVal(a.treatmentTypeName);
    setChecked(a.activeStatus == 1);
  }, [a]);
  return (
    <div
      className="list-type mb-2"
      style={{ border: !validate(val) ? "1px solid red" : "" }}
    >
      <input
        type="text"
        placeholder="Hospital types"
        className="text-custom-contain add-new"
        name="treatment_type_name"
        value={val}
        disabled={!PermissionCheck("user_management", "update")}
        onBlur={(e) => onChange(a.id, e)}
        onChange={(e) => setVal(e.target.value)}
      />
      <div className="d-flex align-center">
        <AntSwitch
          disabled={!PermissionCheck("treatment_types", "update")}
          checked={checked}
          onChange={(e) => {
            setChecked(e.target.checked);
            onChange(a.id, e, true);
          }}
          name="active_status"
          inputProps={{ "aria-label": "ant design" }}
        />
        {PermissionCheck("treatment_types", "delete") && (
          <img
            src={dele}
            onClick={() =>
              openDelete(
                "Are you sure you want to delete this treatment?",
                true,
                a.id
              )
            }
            className="delete-icon cursur mx-2 action-icon"
          />
        )}
      </div>
    </div>
  );
};
export default React.memo(Treatments);
